"use client";

export const runtime = "edge";

import { useEffect } from "react";
import Link from "next/link";
import { ChevronRight, Pin } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getInformationList } from "@/store/controller/information.controller";
import { formatDate } from "../../components/landing/format";
import { getCategoryColor } from "../../components/landing/theme";

export default function PengumumanListPage() {
  const dispatch = useAppDispatch();
  const information = useAppSelector((state) => state.information.list);
  const announcements = information.filter((item) => item.type === "pengumuman");

  useEffect(() => {
    dispatch(getInformationList({ type: "pengumuman", limit: 100 }));
  }, [dispatch]);

  return (
    <div className="pt-24 sm:pt-28">
      <div className="bg-green-800 py-12 sm:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-green-300 text-sm mb-4">
            <Link href="/" className="hover:text-white transition-colors">
              Beranda
            </Link>
            <ChevronRight size={14} />
            <span className="text-white">Pengumuman</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">Pengumuman</h1>
          <p className="text-green-200 max-w-xl">Informasi resmi dan pengumuman penting dari SMAIT Ihsanul Fikri.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="space-y-4">
          {announcements.map((announcement) => (
            <Link
              key={announcement.id}
              href={`/pengumuman/${announcement.id}`}
              className={`relative p-5 rounded-2xl border-l-4 flex items-start gap-4 hover:shadow-md transition-all ${
                announcement.pinned ? "bg-orange-50 border-orange-500 border border-l-4" : "bg-white border-green-400 border border-l-4"
              }`}
            >
              {announcement.pinned && (
                <div className="absolute top-3 right-4 flex items-center gap-1 text-orange-600 text-xs font-bold">
                  <Pin size={12} />
                  Penting
                </div>
              )}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${getCategoryColor(announcement.category_id)}`}>
                    {announcement.category?.name}
                  </span>
                  <span className="text-gray-400 text-xs">{formatDate(announcement.date)}</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-1">{announcement.title}</h3>
                <p className="text-gray-500 text-sm">{announcement.excerpt || announcement.content}</p>
              </div>
              <ChevronRight size={20} className="text-gray-300 flex-shrink-0 mt-1" />
            </Link>
          ))}
        </div>
        {announcements.length === 0 && <p className="text-center text-gray-400">Belum ada pengumuman.</p>}
      </div>
    </div>
  );
}
